"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'project.icon.help': 'Introducir clase de icono FontAwesome (ej. fas fa-folder)',
};
